<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  process: { type: Object, default: null },
  saleSummary: { type: Object, default: null },
});

const emit = defineEmits(['details']);
const { t } = useI18n();
const processData = computed(() => props.process || {});
const summary = computed(() => props.saleSummary || {});
const emptyValue = computed(() => t('REAL_ESTATE_FINANCE.DETAIL.EMPTY_VALUE'));
const money = value => value?.amount ?? emptyValue.value;
const value = input => input || emptyValue.value;
</script>

<template>
  <section
    data-testid="finance-sale-summary"
    class="rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <header class="flex items-center gap-2">
      <span class="i-lucide-info size-5 text-lais-primary" aria-hidden="true" />
      <h2 class="font-semibold text-lais-text">
        {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_SUMMARY_TITLE') }}
      </h2>
    </header>
    <dl class="mt-4 grid gap-4 sm:grid-cols-2">
      <div>
        <dt class="text-sm text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_SUMMARY_DNA') }}
        </dt>
        <dd class="mt-1 font-medium text-lais-text">
          {{ money(summary.valor_dna) }}
        </dd>
      </div>
      <div>
        <dt class="text-sm text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_SUMMARY_STORE') }}
        </dt>
        <dd class="mt-1 font-medium text-lais-text">
          {{ value(processData.loja?.name) }}
        </dd>
      </div>
      <div>
        <dt class="text-sm text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_SUMMARY_BENESH') }}
        </dt>
        <dd class="mt-1 font-medium text-lais-text">
          {{ money(summary.valor_benesh) }}
        </dd>
      </div>
      <div>
        <dt class="text-sm text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_SUMMARY_SIGNATURE_DATE') }}
        </dt>
        <dd class="mt-1 font-medium text-lais-text">
          {{ value(processData.data_assinatura) }}
        </dd>
      </div>
      <div>
        <dt class="text-sm text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_SUMMARY_TOTAL_RECEIVABLE') }}
        </dt>
        <dd class="mt-1 font-semibold text-lais-primary">
          {{ money(summary.valor_total_dna) }}
        </dd>
      </div>
    </dl>
    <footer class="mt-4 border-t border-lais-border-soft pt-3">
      <LaisPrimaryButton size="sm" variant="ghost" @click="emit('details')">
        {{ t('REAL_ESTATE_FINANCE.DETAIL.OPEN_SALE') }}
      </LaisPrimaryButton>
    </footer>
  </section>
</template>
